// Report styles for Material UI and dashboard elements

export const reportStyles = {

    button: {color: '#607d8b'},

    dash: {flex: {display: 'flex'}},
    dashContainer: {position: 'relative', marginRight: '1em'},
    dashTitle: {width: 'calc(100% - 180px)', boxSizing: 'border-box'},

    marginBottom: {marginBottom: '2em'},
    marginRight: {marginRight: '1em'},

    headerButton: {
        display: 'inline-block',
        color: '#ffffff',
        margin: '0 10px 0 0',
    },
    headerButtonIcon: {
        display: 'inline-block',
        color: '#ffffff',
        margin: '0 6px 0 8px',
        verticalAlign: 'middle',
    },
    headerButtonLink: {
        display: 'inline-block',
        fontWeight: 500,
        color: '#ffffff',
        textTransform: 'uppercase',
        textDecoration: 'none',
        margin: '0 12px 0 0'
    },

    loaderContainer: {textAlign: 'center', margin: '1em auto 1em auto'},
    loaderContainerLeft: {display: 'block', textAlign: 'left', margin: '1em 0 1em 1em'},
    loader: {
        display: 'inline-block',
        margin: '0 0 0 8px',
        verticalAlign: 'middle',
    },

    summaryIcon: {
        fill: '#f5f5f5',
        width: 36,
        height: 36,
        margin: '0 10px 0 0',
        verticalAlign: 'middle'
    },
    summaryIconSmall: {
        fill: '#f5f5f5',
        width: 30,
        height: 30,
        margin: '0 8px 0 0',
        verticalAlign: 'middle'
    },
    buttonRaised: {color: '#1478b9'},

    tableDetail: {lineHeight: '1.3', margin: '10px 0 2px 0', padding: '0 0 0 46px'}
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-reports.js